export default __webpack_public_path__ + "assets/60c6ffceb8602c82faa30f86544cbabd.jpeg";